import Vue from 'vue';

export const staticBreadcrumbs = Vue.observable({ items: [] });
